import React, { Component } from 'react';
import { RESTExecutor, withDomains } from '../../lib/domain';
import {
    PageHeader,
    Typography,
    Divider,
    Table,
    Row,
    Button,
    Tabs,
    Input,
    message,
    Popconfirm
} from 'antd';

import { Link } from 'react-router-dom';
import { PopUpForm } from '../../lib/ui/popupform';
import ErrorWrapper from '../../lib/error_wrapper';
import { showErrorInNotification, copyStringToClipboard, NetworkDelaySearch, overrideHeaderTitle, overrideHeaderBack, formatMoney } from '../../lib/util';
import { BasicHeader } from '../../components/basic_header';
import { setting_quick_menu } from '../../util/ui_util';
import { TransparentButton } from '../../components/basic_items';

const queryString = require('query-string');

const { Title, Paragraph, Text } = Typography;
const form_schema = [
    {
        name: 'Reference Name',
        index: 'name',
        type: 'text'
    }, {
        name: 'Type',
        index: 'type',
        type: 'select',
        options: [
            {
                text: "PARSER",
                value: "PARSER"
            },
            {
                text: "NORMALIZER",
                value: "NORMALIZER"
            }
        ]
    },
    {
        name: "Configuration",
        index: 'config',
        type: 'json',
        default:{"sdad":1}
    }
]
class ReferencesSetting extends Component {
    constructor(props) {
        super(props)

        this.state = {
            form_data: {
            },
            edit_id: null,
            filter_query: {
                per_page: 100,
                page: 1
            },
        }
        this.list_references = RESTExecutor
            .list()
            .config({
                label: 'list', params: {
                    per_page: 100,
                    page: 1
                }
            })
            .callbacks((success) => { })
            .connect(props.domains.references);

        this.post_reference = RESTExecutor
            .post()
            .config({ label: 'list' })
            .callbacks(() => {
                this
                    .list_references
                    .execute();
                this.setState({ modal_open: false });
            }, (error) => {


                console.log("ERROR", error)
            })
            .connect(props.domains.references);

        this.patch_reference = RESTExecutor
            .patch()
            .config({ label: 'detail' })
            .callbacks(() => {
                this
                    .list_references
                    .execute()
                this.setState({ modal_open: false });
            }, (error) => {
                console.log("ERROR", error)
            })
            .connect(props.domains.references);
        this.delete_references = RESTExecutor.delete().config({
            label: 'detail'
        }).callbacks(() => {
            message.success("Deleted Successfully");
            this
                .list_references
                .execute()
        }, (error) => {
            console.log("ERROR", error)
            showErrorInNotification(error);
        })
            .connect(props.domains.references);

        this.delay_search = new NetworkDelaySearch();


    }

    handlePostPatch = (data) => {
        if (this.state.edit_id) {
            //  handle patch
            this
                .patch_reference
                .forId(this.state.edit_id)
                .execute(data)
        } else {
            this
                .post_reference
                .execute(data);
        }

    }

    stateUpdater = ({
        stateKey,
        valueKey,
        value,
        appendObj = {},
        callback
    }) => {
        let newData = this.state[stateKey];
        this.has_changed = true;
        if (valueKey) {
            newData[valueKey] = value;
        }
        if (appendObj) {
            Object.assign(newData, appendObj)
        }
        console.log(newData);
        this.setState({
            [stateKey]: newData
        }, () => {
            typeof callback === 'function' && callback()
        })
    }


    render() {
        let list_reference_resp = this
            .list_references
            .response();
        let list_reference_data = list_reference_resp.result || {};
        let rowsData = list_reference_data.rows || [];
        let rowsMeta = list_reference_resp.meta || {}
        const { filter_query } = this.state;

        let post_reference_res = this
            .post_reference
            .response();
        let patch_reference_res = this
            .patch_reference
            .response();
        let delete_references_res = this.delete_references.response();

        console.log("rows meta",rowsMeta)
        return (
            <div>
                <BasicHeader no_back title="References"
                    menu_items={setting_quick_menu}
                    right={[
                        <TransparentButton
                            label="Add New"
                            className='cta-primary'
                            hint="Add New Reference"
                            onClick={() => {
                                this.setState({ form_data: {}, edit_id: null, modal_open: true })
                            }}

                        />
                    ]}

                />
                <div className='filter-card'>
                    <div className='filter-card-top' style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        flexWrap: 'nowrap',
                    }}>
                        <Input.Search
                            allowClear
                            autoFocus
                            placeholder="Search For"
                            style={{
                            }}
                            value={filter_query.query}
                            onChange={(e) => {
                                this.stateUpdater({
                                    stateKey: 'filter_query', valueKey: 'query', value: e.target.value,
                                    callback: () => {
                                        this.delay_search.onSearch(() => {
                                            this.props.history.push({
                                                // pathname:"users",
                                                search: queryString.stringify({ ...this.state.filter_query, per_page: 100, page: 1 })
                                            })
                                        })
                                    }
                                })
                            }}
                        />
                    </div>
                </div>

                <ErrorWrapper
                    // error={list_reference_resp}
                    onReload={() => {
                        this.list_references.execute()
                    }}
                >
                    <div
                        className='default-card'
                        style={{
                            padding: 8
                        }}>
                        <PopUpForm
                            title={"References"}
                            forCreate={this.state.edit_id
                                ? false
                                : true}
                            initialData={this.state.form_data}
                            fields={form_schema}
                            open={this.state.modal_open}
                            networkState={this.state.edit_id
                                ? patch_reference_res
                                : post_reference_res}
                            onClose={() => this.setState({ modal_open: false })}
                            onSubmit={(data) => {
                                console.log("DATA", data);
                                this.handlePostPatch(data);
                            }} />
                        <Table
                            scroll={{ x: true }}
                            rowClassName='hand-cursor'
                            className='main-table'
                            loading={list_reference_resp.fetching || delete_references_res.fetching}
                            size='small'
                            pagination={{
                                simple: false,
                                position: 'bottom',
                                onChange: (current, size) => {
                                    this.props.history.push({
                                        search: queryString.stringify({ ...this.state.filter_query, per_page: size, page: current })
                                    })
                                },
                                defaultCurrent: 1,
                                current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
                                pageSize: (rowsMeta && rowsMeta.requested_count), 
                                total: (rowsMeta && rowsMeta.total_count), 
                                showTotal: (total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`
                            }}

                            rowKey={(record) => record.id} columns={[
                                {
                                    title: "Reference Name",
                                    dataIndex: 'name',
                                    key: 'name'
                                }, {
                                    title: "Type",
                                    dataIndex: 'type',
                                    key: 'type',

                                }, {
                                    title: "",
                                    dataIndex: "id",
                                    key: 'id',
                                    render: (id, data) => {
                                        return <span><Button
                                            type='link'
                                            onClick={() => {
                                                this.setState({ form_data: JSON.parse(JSON.stringify(data)), edit_id: id, modal_open: true })
                                            }}>Edit</Button>
                                            <Divider type='vertical' />
                                            <Popconfirm
                                                onConfirm={() => {
                                                    this.delete_references.forId(id).execute();
                                                }}
                                                title="Are you sure you want to delete this reference?">
                                                <Button
                                                    type='link'
                                                    style={{
                                                        color: 'red'
                                                    }}>Delete</Button>
                                            </Popconfirm>

                                        </span>
                                    }
                                }
                            ]} dataSource={rowsData} />
                    </div>
                </ErrorWrapper>
            </div>
        )
    }
    componentDidMount() {
        overrideHeaderTitle("References")
        overrideHeaderBack(null);

        let new_filter_query = {};
        if (this.props.location && this.props.location.search) {
            const parsed = queryString.parse(this.props.location.search);
            new_filter_query = parsed;
        }
        this.setState({
            filter_query: {
                per_page: 100,
                page: 1,
                ...new_filter_query
            }
        }, () => {
            this.list_references.config({
                params: {
                    ...this.state.filter_query
                }
            }).execute()
        })

    }
    componentWillReceiveProps(nextProps) {

        let new_filter_query = {};
        if ((this.props.location.search !== nextProps.location.search)) {
            const parsed = queryString.parse(nextProps.location.search);
            new_filter_query = parsed;
            this.setState({
                filter_query: {
                    per_page: 100,
                    page: 1,
                    ...new_filter_query
                }
            }, () => {
                this.list_references.config({
                    params: {
                        ...this.state.filter_query
                    }
                }).execute()
            })
        } else {
            //   this.list_logs.execute()
        }


    }
}

export default withDomains(ReferencesSetting, "references");
